/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Rule_TitleInputs */

const en_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Rules`)
};

const ar_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قواعد الحدث`)
};

const de_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsregeln`)
};

const es_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normas del evento`)
};

const fr_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règles de l'Évènement`)
};

const it_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regole dell'Evento`)
};

const ja_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントルール`)
};

const ko_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 규정`)
};

const pt_br_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras do evento`)
};

const ru_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила события`)
};

const th_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กฎกติกาของอีเวนต์`)
};

const tr_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik Kuralları`)
};

const zh_cn_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动规则`)
};

const zh_tw_event_rule_title = /** @type {(inputs: Event_Rule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動規則`)
};

/**
* | output |
* | --- |
* | "Event Rules" |
*
* @param {Event_Rule_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_rule_title = /** @type {((inputs?: Event_Rule_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Rule_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_rule_title(inputs)
	if (locale === "ar") return ar_event_rule_title(inputs)
	if (locale === "de") return de_event_rule_title(inputs)
	if (locale === "es") return es_event_rule_title(inputs)
	if (locale === "fr") return fr_event_rule_title(inputs)
	if (locale === "it") return it_event_rule_title(inputs)
	if (locale === "ja") return ja_event_rule_title(inputs)
	if (locale === "ko") return ko_event_rule_title(inputs)
	if (locale === "pt_br") return pt_br_event_rule_title(inputs)
	if (locale === "ru") return ru_event_rule_title(inputs)
	if (locale === "th") return th_event_rule_title(inputs)
	if (locale === "tr") return tr_event_rule_title(inputs)
	if (locale === "zh_cn") return zh_cn_event_rule_title(inputs)
	return zh_tw_event_rule_title(inputs)
});